import { SelectedTreatmentsDetails } from "../../domain/selectedTreatments";
import { DataCard } from "../common/DataCard";
import { Menu, treatmentOptions } from "domain/menuOptions";
import { EditButton } from "components/common/EditButton";
import { VisibleSection } from "components/common/VisibleSection";
import { RequestRepaymentHolidaySummary } from "./RequestRepaymentHolidaySummary";
import { ExtendTermSummary } from "./ExtendTermSummary";

type SelectedTreatmentOptionSummaryProps = {
  selectedTreatments: SelectedTreatmentsDetails;
  onEdit: () => void;
};

export const SelectedTreatmentOptionSummary = (
  props: SelectedTreatmentOptionSummaryProps
) => {
  const visibleRepaymentHoliday =
    props.selectedTreatments.treatmentOptionType ===
    Menu.RequestRepaymentHoliday;
  const isExtendTerm =
    props.selectedTreatments.treatmentOptionType === Menu.ExtendTerm;

  return (
    <>
      <div className="appSummary">
        <DataCard>
          <div className="selectedTreatementOption">
            <div className="headerContainer  sub-heading">
              <div className="zb-heading3 ">
                {treatmentOptions(props.selectedTreatments.selectedOptionType!)}
              </div>
              <EditButton onEdit={props.onEdit} />
            </div>
            <VisibleSection visible={visibleRepaymentHoliday}>
              <RequestRepaymentHolidaySummary
                selectedTreatments={props.selectedTreatments}
              />
            </VisibleSection>
            <VisibleSection visible={isExtendTerm}>
              <ExtendTermSummary
                selectedTreatments={props.selectedTreatments}
              />
            </VisibleSection>
          </div>
        </DataCard>
      </div>
    </>
  );
};
